import { useState } from "react";
import { faqs } from "@/mocks/articles";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于吃瓜，你常问的几件事</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-500">
            我们是谁、内容是否可信、如何投稿分享线索。把关心的问题先摆到明面上，理性吃瓜从了解编辑部开始。
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-lg bg-secondary-100 px-4 py-3 text-sm text-secondary-900">
            <i className="ri-lightbulb-flash-line text-secondary-600"></i>
            看完还有疑问？欢迎到「关于我们」页留言提问。
          </div>
        </div>

        <div className="lg:col-span-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="rounded-xl border border-background-200 bg-background-50 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug">{f.q}</h3>
                  <span className={`flex items-center justify-center w-7 h-7 shrink-0 rounded-full transition-colors ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"}`}>
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pt-1">
                    <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}